require('./command.js');

PegasusTemplate.EditBodyImageCommand = PegasusTemplate.Command.extend({
  description: function(){
    return Em.I18n.t('command_descriptions.changed_email_backdrop');
  }.property(),
  executeColor:null,
  unexecuteColor:null,

  executeImage:null,
  unexecuteImage:null,

  execute: function(){
    PegasusTemplate.lookupController('toolbar').setProperties({
      selectedBackgroundImage: this.get('executeImage'),
      selectedBackgroundColor: this.get('executeColor'),
      selectedBackgroundImageCovers: this.get('executeStyle')
    });
    this._super();
  },
  unexecute: function(){
    PegasusTemplate.lookupController('toolbar').setProperties({
      selectedBackgroundImage: this.get('unexecuteImage'),
      selectedBackgroundColor: this.get('unexecuteColor'),
      selectedBackgroundImageCovers: this.get('unexecuteStyle')
    });
    this._super();
  }
});
